import { render } from "./AddAttestationPage.vue?vue&type=template&id=6e86d9c4&ts=true"
import script from "./AddAttestationPage.vue?vue&type=script&lang=ts"
export * from "./AddAttestationPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__